// Angular Core and Common Modules
import { APP_INITIALIZER, Injector, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { Router, RouteReuseStrategy } from "@angular/router";

// Ionic Modules and Services
import {
  IonicModule,
  IonicRouteStrategy,
  Platform,
} from "@ionic/angular";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// Angular HttpClient and Interceptors
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

// Cordova Plugins
import { TouchID } from "@awesome-cordova-plugins/touch-id/ngx";
import { Device } from "@awesome-cordova-plugins/device/ngx";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { FileOpener } from "@awesome-cordova-plugins/file-opener/ngx";

// Third-party Modules
import { NgIdleModule } from '@ng-idle/core';

// Application Services
import { AuthenticationService } from "./services/authentication/authentication.service";
import { GlobalErrorHandlerService } from "./services/global-errors/global-error-handler.service";
import { UserSessionService } from "./services/user-session/user-session.service";
import { LogoutService } from "./services/logout/logout.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ConfigService } from "./services/config/config.service";
import { IonicStorageModule } from "@ionic/storage-angular";
import { CommonModule, DatePipe } from "@angular/common";
import { AuthGuardService } from "./services/auth-guard/auth-guard.service";
import { NotificationApiService } from "./services/notification-api/notification-api.service";
import { AppstorageTsService } from "./services/appstorage/appstorage.ts.service";
import { MarketingService } from "./services/marketing/marketing.service";

// Shared and Component Modules
import { ServicesSharedModule } from "./services/services-shared.module";
import { ComponentsModule } from "./components/components.module";
import { pagesModule } from "./pages/pages.module";

// Application Routes and Animations
import { customTabAnimation } from "./animation/animation";
import { TabLandingPageModule } from "./tabs/tab-landing/tab-landing.module";
import { COMMON_MODAL_COMPONENT_ROUTES, MOBILE_ROUTES, NJ_ROUTES, PA_ROUTES, SPLASH_ROUTES } from "./app-routes";

//import { ApplePay } from "@awesome-cordova-plugins/apple-pay/ngx";



const ADD_MODAL_COMPONENT_ROUTES = [];
for (let index = 0; index < COMMON_MODAL_COMPONENT_ROUTES.length; index++) {
  ADD_MODAL_COMPONENT_ROUTES.push(COMMON_MODAL_COMPONENT_ROUTES[index]);
}


 function init_app(
  injector: Injector,
  config: ConfigService,
  appstorageTsService: AppstorageTsService,
  marketingService: MarketingService,
  platform: Platform
) {
  return () =>
    new Promise((resolve) => {
      let routes = [];
      if (platform.is("capacitor")) {
        config.isLoaded().then(() => {
          //routes = MOBILE_ROUTES;
          const ALL_MOBILE_ROUTES = [...COMMON_MODAL_COMPONENT_ROUTES, ...MOBILE_ROUTES]
          routes = ALL_MOBILE_ROUTES;
          const router: Router = injector.get(Router);
          router.resetConfig(routes);
          resolve(this);
        })

      } else {
        config.isLoaded().then(() => {

          switch (config.getDeafaultRoute()) {
            case "/":
              routes = SPLASH_ROUTES;
              break;
            case "casino":
              //routes = NJ_ROUTES;
              const ALL_NJ_ROUTES = [...COMMON_MODAL_COMPONENT_ROUTES, ...NJ_ROUTES]
              routes = ALL_NJ_ROUTES;
              break;
            case "casino/valley-forge":
              //routes = PA_ROUTES;
              const ALL_PA_ROUTES = [...COMMON_MODAL_COMPONENT_ROUTES, ...PA_ROUTES]
              routes = ALL_PA_ROUTES;
              break;
            default:
              routes = SPLASH_ROUTES;
              break;
          }
          const router: Router = injector.get(Router);
          router.resetConfig(routes);
          resolve(this);
        });
      }
    });
}

const ionicRootOptions = {
  rippleEffect: false,
  navAnimation: customTabAnimation,
  innerHTMLTemplatesEnabled: true,
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        IonicModule.forRoot(ionicRootOptions),
        IonicStorageModule.forRoot(),
        AppRoutingModule,
        ReactiveFormsModule,
        ServicesSharedModule,
        ComponentsModule,
        CommonModule,
        FormsModule,
        pagesModule,
        NgIdleModule.forRoot(),
        TabLandingPageModule], providers: [
        ConfigService,
        AppstorageTsService,
        MarketingService,
        Platform,
        {
            provide: APP_INITIALIZER,
            useFactory: init_app,
            deps: [Injector, ConfigService, AppstorageTsService, MarketingService, Platform],
            multi: true,
        },
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy,
        },
        AuthenticationService,
        GlobalErrorHandlerService,
        LogoutService,
        NotificationApiService,
        UserSessionService,
        AuthGuardService,
        InAppBrowser,
        TouchID,
        Device,
        DatePipe,
        CommonModule,
        ScreenOrientation,
        FileOpener,
        provideHttpClient(withInterceptorsFromDi()),
        {
          provide: 'APPLE_PAY',
          useFactory: (platform: Platform) => {
            if (platform.is('ios')) {
              try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const ApplePay = require('@ionic-native/apple-pay/ngx').ApplePay;
                return new ApplePay();
              } catch {
                return null;
              }
            }
            return null;
          },
          deps: [Platform]
        },
        {
          provide: 'IOS_WEB_AUTH_SESSION',
          useFactory: (platform: Platform) => {
            if (platform.is('ios') && platform.is('capacitor')) {
              try {
                const { BankConnectAuth } = require('capacitor-plugin-webauth-session');
                return BankConnectAuth;
              } catch {
                return null;
              }
            }
            return null;
          },
          deps: [Platform]
        }
    ] })
export class AppModule { }
